/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_YesInputs */

const id_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya`)
};

const ms_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya`)
};

const da_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const de_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const en_us2_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const es_es2_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const es_mx2_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const fil_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oo`)
};

const fr_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const it_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì`)
};

const hu_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Igen`)
};

const nl_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const no_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const pl_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tak`)
};

const pt_br2_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const pt_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

const ro_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da`)
};

const fi_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kyllä`)
};

const sv_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const vi_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có`)
};

const tr_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evet`)
};

const cs_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano`)
};

const bg_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const ru_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const uk_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Так`)
};

const ar_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نعم`)
};

const hi_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const th_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช่`)
};

const ja_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const zh_cn2_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const zh_hant1_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const ko_forms_review_yes = /** @type {(inputs: Forms_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Forms_Review_YesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_yes = /** @type {((inputs?: Forms_Review_YesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_YesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_yes(inputs)
	if (locale === "ms") return ms_forms_review_yes(inputs)
	if (locale === "da") return da_forms_review_yes(inputs)
	if (locale === "de") return de_forms_review_yes(inputs)
	if (locale === "en-US") return en_us2_forms_review_yes(inputs)
	if (locale === "es-ES") return es_es2_forms_review_yes(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_yes(inputs)
	if (locale === "fil") return fil_forms_review_yes(inputs)
	if (locale === "fr") return fr_forms_review_yes(inputs)
	if (locale === "it") return it_forms_review_yes(inputs)
	if (locale === "hu") return hu_forms_review_yes(inputs)
	if (locale === "nl") return nl_forms_review_yes(inputs)
	if (locale === "no") return no_forms_review_yes(inputs)
	if (locale === "pl") return pl_forms_review_yes(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_yes(inputs)
	if (locale === "pt") return pt_forms_review_yes(inputs)
	if (locale === "ro") return ro_forms_review_yes(inputs)
	if (locale === "fi") return fi_forms_review_yes(inputs)
	if (locale === "sv") return sv_forms_review_yes(inputs)
	if (locale === "vi") return vi_forms_review_yes(inputs)
	if (locale === "tr") return tr_forms_review_yes(inputs)
	if (locale === "cs") return cs_forms_review_yes(inputs)
	if (locale === "bg") return bg_forms_review_yes(inputs)
	if (locale === "ru") return ru_forms_review_yes(inputs)
	if (locale === "uk") return uk_forms_review_yes(inputs)
	if (locale === "ar") return ar_forms_review_yes(inputs)
	if (locale === "hi") return hi_forms_review_yes(inputs)
	if (locale === "th") return th_forms_review_yes(inputs)
	if (locale === "ja") return ja_forms_review_yes(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_yes(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_yes(inputs)
	return ko_forms_review_yes(inputs)
});
export { forms_review_yes as "forms.review.yes" }